import {FORMAT} from "ubs-framework/v2/common/constant";
import moment from "moment";

export const downloadBase64ToPDF = (base64String, filename = `pdf-file-${moment().format(FORMAT.FULL_DATE_TIME)}`) => {
    try {
        // Convert Base64 string to a data URI
        const dataURI = `data:application/pdf;base64,${base64String}`;

        // Create a temporary anchor tag
        const anchor = document.createElement('a');
        anchor.href = dataURI;
        anchor.download = filename || 'document.pdf';
        // Trigger the download
        anchor.click();
    } catch (error) {
        console.log("Download Base64 to PDF catch error =======> ", error)
    }
};